import { render, staticRenderFns } from "./customerLocation.vue?vue&type=template&id=21a3e5d5&"
import script from "./customerLocation.vue?vue&type=script&lang=js&"
export * from "./customerLocation.vue?vue&type=script&lang=js&"
import style0 from "./customerLocation.vue?vue&type=style&index=0&id=21a3e5d5&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports